import "./Technologies.css";

const Technologies = () => {
  return (
    <div className="portfolio-tech-stack-section">
      <h1 className="heading-2">Technologies</h1>
      <h1 className="portfolio-page-tech-header">Languages</h1>
      <div className="portfolio-page-tech-stack-div">
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/js-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">JavaScript</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="/images/sql-svgrepo-com.svg"zx
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">SQL</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/html5-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">HTML</div>
        </div>

        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/css-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">CSS</div>
        </div>
      </div>
      <h1 className="portfolio-page-tech-header">Frameworks</h1>
      <div className="portfolio-page-tech-stack-div">
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/react-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">React</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/nextjs-icon-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">Next.js</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/nodejs-icon-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">Node.js</div>
        </div>
      </div>
      <h1 className="portfolio-page-tech-header">Other Technologies</h1>
      <div className="portfolio-page-tech-stack-div">
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/mysql-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">MySQL</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/git-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">Git</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/webflow-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">Webflow</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/digitalocean-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">DigitalOcean</div>
        </div>
        <div className="portfolio-page-tech-info-div">
          <div className="portfolio-page-tech-image-div">
            <img
              src="images/netlify-svgrepo-com.svg"
              loading="lazy"
              alt=""
              className="portfolio-page-tech-image"
            />
          </div>
          <div className="portfolio-page-tech-title">Netlify</div>
        </div>
      </div>
    </div>
  );
};

export default Technologies;
